import api from './http';

// Google Calendar
export const getCalendarStatus = () => api.get('/oauth/calendar/status');
export const startCalendarOAuth = () => api.get('/oauth/calendar/login');
export const disconnectCalendar = () => api.delete('/oauth/calendar/disconnect');
export const getCalendarEvents = (days = 30) => api.get(`/calendar/events?days=${days}`);
export const syncTasksToCalendar = () => api.post('/calendar/sync-tasks');
export const syncSchedulesToCalendar = () => api.post('/calendar/sync-schedules');
export const saveCalendarSettings = (data) => api.post('/calendar/settings', data);
export const getCalendarSettings = () => api.get('/calendar/settings');
export const rescheduleCalendarEvent = (eventId, newDate) => api.patch(`/calendar/events/${eventId}/reschedule`, { new_date: newDate });
